import { createTheme as C } from "./ghl-ui.es901.js";
import h from "./ghl-ui.es1192.js";
import f from "./ghl-ui.es1198.js";
const b = (e) => {
  const {
    modalColor: t,
    textColor1: l,
    textColor2: i,
    boxShadow3: d,
    lineHeight: s,
    fontWeightStrong: c,
    dividerColor: o,
    closeColorHover: a,
    closeColorPressed: n,
    closeIconColor: p,
    closeIconColorHover: x,
    closeIconColorPressed: m,
    borderRadius: r,
    primaryColorHover: g
  } = e;
  return {
    bodyPadding: "16px 24px",
    borderRadius: r,
    headerPadding: "16px 24px",
    footerPadding: "16px 24px",
    color: t,
    textColor: i,
    titleTextColor: l,
    titleFontSize: "18px",
    titleFontWeight: c,
    boxShadow: d,
    lineHeight: s,
    headerBorderBottom: `1px solid ${o}`,
    footerBorderTop: `1px solid ${o}`,
    closeIconColor: p,
    closeIconColorHover: x,
    closeIconColorPressed: m,
    closeSize: "22px",
    closeIconSize: "18px",
    closeColorHover: a,
    closeColorPressed: n,
    closeBorderRadius: r,
    resizableTriggerColorHover: g
  };
}, S = C({
  name: "Drawer",
  common: h,
  peers: {
    Scrollbar: f
  },
  self: b
}), P = S;
export {
  P as default,
  b as self
};
